/**
 * Common map view settings keys
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const MAP_VIEW_KEYS = {
  LAYER_VISIBLE: 'visible',
  LAYER_DATA_VIEW_ID: 'dataViewId',
  LAYER_NAME: 'layerName',
  LAYER_TYPE: 'layerType',
  LAYER_REFERENCE_REPOSITORY_NAME: 'repositoryName',
  LAYER_REFERENCE_REPOSITORY_ITEM_NAME: 'repositoryItemName',
  INITIAL_EXTENT: 'map.initialExtent',
  TOGGLE_LAYER_ACTIVE_THEME_ID: 'activeThemeID',
  GROUP_LAYER_ORDERING: 'groupLayerOrdering',
  GROUP_LAYER_VISIBILITIES: 'groupLayerVisibilities',
  DISPLAY_SPATIAL_FILTER_GEOMETRIES: 'displaySpatialFilterGeometry',
  SKETCH_LAYER_REPOSITORY_NAME: 'sketchLayer.repositoryName',
  SKETCH_LAYER_CONTENT_IDENTIFIER: 'sketchLayer.contentIdentifier'

};
